var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tourism-button-new",on:{"click":_vm.newTourism}},[_vm._v("\n  新しい観光ポイントの作成\n")])}
var staticRenderFns = []

export { render, staticRenderFns }